import { ProductData } from "@/lib/content-service/types/ContentServiceProduct"
import logger from "@/lib/logger/logger-init"
import {
    CheckoutAPIProduct,
    RelatedProduct
} from "@/types/centra/checkout-api/products/post-products"

const ABSOLUTE_SITE_DOMAIN = process.env.NEXT_PUBLIC_SITEMAP_DOMAIN || "https://poc.com"
export const klaviyoViewedProductEvent = (
    product: CheckoutAPIProduct | RelatedProduct | ProductData,
    item: any
) => {
    const {
        product: ProductID,
        priceAsNumber,
        priceBeforeDiscountAsNumber,
        sku,
        name,
        brandName,
        categoryName,
        uri
    } = product || {}

    const imageURL = product?.media?.small
        ? (product as ProductData)?.media?.small?.[0]?.url ?? ""
        : (product as CheckoutAPIProduct)?.mediaObjects?.[0]?.sources?.small?.[0]?.url ??
          ""

    const productURL = `${ABSOLUTE_SITE_DOMAIN}/product/${uri}`
    const eventData = {
        ProductName: name,
        ProductID,
        SKU: item?.sku || sku,
        Categories: categoryName,
        ImageURL: imageURL,
        URL: productURL,
        Brand: brandName,
        Price: priceAsNumber,
        CompareAt: priceBeforeDiscountAsNumber
    }

    logger.debug("klaviyoViewedProductEvent", eventData)
    if (window.klaviyo) {
        window.klaviyo.push(["track", "Viewed Product", eventData])
    }

    // trackViewedItem -  allows entries to be added to a “Recently Viewed Items” table for a profile in Klaviyo
    const trackViewedItemData = {
        Title: name,
        ItemId: ProductID,
        Categories: categoryName,
        ImageUrl: imageURL,
        Url: productURL,
        Metadata: {
            Brand: brandName,
            Price: priceAsNumber,
            CompareAtPrice: priceBeforeDiscountAsNumber
        }
    }
    logger.debug("klaviyoTrackViewedItem", trackViewedItemData)
    if (window.klaviyo) {
        window.klaviyo.push(["trackViewedItem", trackViewedItemData])
    }
}

export const klaviyoAddedToCartEvent = (
    product: CheckoutAPIProduct | RelatedProduct | ProductData,
    item: any
) => {
    const {
        product: ProductID,
        priceAsNumber,
        sku,
        name,
        categoryName,
        uri
    } = product || {}

    const imageURL = product?.media?.small
        ? (product as ProductData)?.media?.small?.[0].url
        : (product as CheckoutAPIProduct)?.mediaObjects?.[0]?.sources?.small?.[0]?.url ??
          ""
    const productURL = `${ABSOLUTE_SITE_DOMAIN}/product/${uri}`

    const eventData = {
        $value: priceAsNumber, //TODO should be total cart value
        AddedItemProductName: name,
        AddedItemProductID: ProductID || (product as ProductData).productId,
        AddedItemSKU: item?.sku || sku,
        AddedItemCategories: categoryName,
        AddedItemImageURL: imageURL,
        AddedItemURL: productURL,
        AddedItemPrice: priceAsNumber,
        AddedItemQuantity: 1,
        //ItemNames: TODO product names in cart
        CheckoutURL: `${ABSOLUTE_SITE_DOMAIN}/checkout`
        //Items: TODO all cart items
    }

    logger.debug("klaviyoAddedToCartEvent", eventData)
    if (window.klaviyo) {
        window.klaviyo.push(["track", "Added to Cart", eventData])
    }
}
